import { WrapperEntitySelector } from '@components/Inputs';
import { Grid, TextInput, Select, Typography, DateTimeInput } from '@ts/storybook';
import { generateSearchEntitySelector } from '@modules/entitySelector/entitySelector.utils';
import { IForm } from '@ts/ui-models';
import { NewPaperWithPadding } from '@components/Misc';

interface IInventoryTabProps extends IForm {}

const InventoryTab = (props: IInventoryTabProps) => {
  const { values, mode, onCallbackChange } = props;
  const isViewMode = mode === 'view';

  return (
    <NewPaperWithPadding className="h-auto">
      <Typography variant="h6" text="Accounting" />

      <TextInput
        label="Inventory ID"
        isReadOnly={isViewMode}
        value={values.inventoryId}
        onChangeValue={onCallbackChange('inventoryId')}
      />

      <DateTimeInput
        label={'Acquisition date'}
        onChange={onCallbackChange('acquisitionDate')}
        value={values.acquisitionDate}
        isReadOnly={isViewMode}
      />

      <TextInput
        type="number"
        isReadOnly={isViewMode}
        label="Accounting useful life"
        value={values.accountingUsefulLife}
        onChangeValue={onCallbackChange('accountingUsefulLife')}
      />

      <DateTimeInput
        label={'Deactivation date'}
        value={values.accountingDeactivationDate}
        onChange={onCallbackChange('accountingDeactivationDate')}
        isReadOnly={isViewMode}
      />
      <Grid container>
        <Grid size={{ xs: 6, md: 9 }}>
          <TextInput
            type="number"
            isReadOnly={isViewMode}
            label="Useful life"
            value={values.usefulLife}
            onChangeValue={onCallbackChange('usefulLife')}
          />
        </Grid>
        <Grid container alignItems="flex-end" size={{ xs: 6, md: 3 }}>
          {(isViewMode && values.usefulLifeUnits) ||
            (!isViewMode && (
              <Select
                options={[
                  { label: 'hours', value: 'hours' },
                  { label: 'days', value: 'days' },
                  { label: 'months', value: 'months' },
                  { label: 'years', value: 'years' },
                ]}
                value={values.usefulLifeUnits}
                onChange={onCallbackChange('usefulLifeUnits')}
                isReadOnly={isViewMode}
              />
            ))}
        </Grid>
      </Grid>

      <TextInput
        isReadOnly={isViewMode}
        label="Cost"
        placeholder=""
        value={values.cost}
        onChangeValue={onCallbackChange('cost')}
      />

      <WrapperEntitySelector
        searchComponent={generateSearchEntitySelector('currency')}
        isReadOnly={isViewMode}
        value={values.currency}
        onChangeEntity={currency => {
          const value = currency ? currency?.getID() : null;
          onCallbackChange('currency')(currency);
          return onCallbackChange('currencyId')(value);
        }}
        label={'Currency'}
        multiple={false}
      />
    </NewPaperWithPadding>
  );
};

export default InventoryTab;
